import { reportError } from './appActions';
import ApiClient from '../../loopback/apiClient';
import {
  loopbackPost,
  loopbackPatch,
} from '../../loopback';
import {
  LOGGED_IN,
  LOGGED_OUT,
  SET_USERS,
  CLEAR_USERS,
  UPDATE_USERS,
  UserActionTypes,
  UserTokenData,
  QuipUser,
  AppThunk,
} from '../types';

export const loggedIn = (email: string, token: UserTokenData): UserActionTypes => ({
  type: LOGGED_IN,
  payload: {
    email,
    token,
  },
});

export const loggedOut = (): UserActionTypes => ({
  type: LOGGED_OUT,
});

export const login = (
  email: string, password: string,
): AppThunk => async (dispatch): Promise<void> => {
  const tokenData = await ApiClient.login(email, password);
  dispatch(loggedIn(email, tokenData));
};

// todo : move to app action
export const showHelp = (helpId: string) => ({
  type: 'SHOW_HELP',
  helpId,
});

// todo : mode to app action
export const hideHelp = () => ({
  type: 'HIDE_HELP',
});

export const requestPasswordReset = (email: string) => () => loopbackPost('quipusers/reset', { email });

const setUsers = (users: QuipUser[]): UserActionTypes => ({
  type: SET_USERS,
  payload: users,
});

export const fetchUsers = (): AppThunk => async (dispatch) => {
  try {
    const res = await ApiClient.getUsers();
    return dispatch(setUsers(res));
  } catch (error) {
    return dispatch(reportError(`Error during fetching Users: ${(error as Error).stack}`));
  }
};

export const clearUsers = (): UserActionTypes => ({ type: CLEAR_USERS });

export const updateUsersRedux = (payload: QuipUser[]): UserActionTypes => ({
  type: UPDATE_USERS,
  payload,
});

export const addUsersToInstitute = (
  instituteId: number, body: {userIds: number[]},
): AppThunk => async (dispatch) => {
  const updatedUsers: QuipUser[] = await ApiClient.addUsersToInstitute(instituteId, body);
  dispatch(updateUsersRedux(updatedUsers));
};
